import { Component, EventEmitter, Input, Output } from '@angular/core';
import { getFullName } from 'src/app/shared/utils/full-name.util';
import { PopupProfile } from '../profile-management.service';

@Component({
  selector: 'app-profile-access-assigned',
  templateUrl: './profile-access-assigned.component.html',
  styleUrls: ['./profile-access-assigned.component.scss'],
})
export class ProfileAccessAssignedComponent {
  @Input() profileDetails!: PopupProfile;
  @Output() viewProfile = new EventEmitter<void>();
  @Output() addAnotherUser = new EventEmitter<void>();

  get userName(): string {
    const p = this.profileDetails;
    return getFullName(p?.firstName, p?.middleName, p?.lastName);
  }
}
